import { gql } from '@apollo/client';

export const CREATE_PORTFOLIO = gql`
  mutation CreatePortfolio($name: String!, $description: String) {
    createPortfolio(name: $name, description: $description) {
      portfolio {
        id
        name
        description
      }
    }
  }
`;

export const UPDATE_PORTFOLIO = gql`
  mutation UpdatePortfolio(
    $portfolioId: ObjectIdType
    $portfolioName: String
    $portfolioDescription: String
    $watchlistEnabled: Boolean
  ) {
    updatePortfolio(
      id: $portfolioId
      name: $portfolioName
      description: $portfolioDescription
      watchlistEnabled: $watchlistEnabled
    ) {
      portfolio {
        id
        name
        description
      }
    }
  }
`;

export const DELETE_PORTFOLIOS = gql`
  mutation DeletePortfolio($portfolioIds: [String]) {
    deletePortfolio(ids: $portfolioIds) {
      ids
    }
  }
`;

/**
 * POSTFOLIO ITEMS / ENTITIES
 */

export const ADD_PORTFOLIO_ITEM = gql`
  mutation AddPortfolioItem($portfolioId: ObjectIdType, $artifactIdList: [ArtifactId]) {
    addPortfolioItem(portfolioId: $portfolioId, artifactIdList: $artifactIdList) {
      portfolioItems {
        module
        artifactId
        addedDate
      }
    }
  }
`;

export const COPY_PORTFOLIO_ITEMS = gql`
  mutation CopyPortfolioItems(
    $portfolioItemsIds: [String]
    $portfolioId: ObjectIdType
    $sourcePortfolioId: ObjectIdType
  ) {
    copyPortfolioItems(
      portfolioItemsIds: $portfolioItemsIds
      portfolioId: $portfolioId
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const COPY_ALL_PORTFOLIO_ITEMS = gql`
  mutation CopyAllPortfolioItems($portfolioId: ObjectIdType, $sourcePortfolioId: ObjectIdType) {
    copyPortfolioItems(portfolioId: $portfolioId, sourcePortfolioId: $sourcePortfolioId) {
      message
    }
  }
`;

export const MOVE_PORTFOLIO_ITEMS = gql`
  mutation MovePortfolioItems(
    $portfolioItemsIds: [String]
    $destinationPortfolioId: ObjectIdType
    $sourcePortfolioId: ObjectIdType
  ) {
    movePortfolioItems(
      portfolioItemsIds: $portfolioItemsIds
      destinationPortfolioId: $destinationPortfolioId
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const MOVE_ALL_PORTFOLIO_ITEMS = gql`
  mutation MoveAllPortfolioItems(
    $sourcePortfolioId: ObjectIdType
    $destinationPortfolioId: ObjectIdType
  ) {
    movePortfolioItems(
      destinationPortfolioId: $destinationPortfolioId
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const DELETE_ENTITIES = gql`
  mutation DeletePortfolioItems(
    $portfolioItemsIds: [String]
    $portfolioId: ObjectIdType
    $selectedAll: Boolean
  ) {
    deletePortfolioItems(
      portfolioItemsIds: $portfolioItemsIds
      portfolioId: $portfolioId
      selectedAll: $selectedAll
    ) {
      message
    }
  }
`;

export const TOGGLE_SIG_MONITORING = gql`
  mutation ToggleSigMonitoring($portfolioId: ObjectIdType, $artifactId: String) {
    toggleSigMonitoring(portfolioId: $portfolioId, artifactId: $artifactId) {
      message
    }
  }
`;

/**
 * INSTRUMENTS
 */

export const ADD_INSTRUMENTS = gql`
  mutation AddInstruments($portfolioId: ObjectIdType, $artifactIdList: [ArtifactId]) {
    addInstruments(portfolioId: $portfolioId, artifactIdList: $artifactIdList) {
      instruments {
        id
      }
    }
  }
`;

export const DELETE_INSTRUMENTS = gql`
  mutation DeleteInstruments(
    $instrumentsIds: [String]
    $portfolioId: ObjectIdType
    $selectedAll: Boolean
  ) {
    deleteInstruments(
      instrumentsIds: $instrumentsIds
      portfolioId: $portfolioId
      selectedAll: $selectedAll
    ) {
      message
    }
  }
`;

export const DELETE_UPLOAD = gql`
  mutation deleteUploadHistory(
    $portfolioId: ObjectIdType
    $uploadsIds: [String]
    $selectedAll: Boolean
  ) {
    deleteUploadHistory(
      portfolioId: $portfolioId
      uploadsIds: $uploadsIds
      selectedAll: $selectedAll
    ) {
      message
    }
  }
`;

export const MOVE_INSTRUMENTS = gql`
  mutation moveInstruments(
    $destinationPortfolioId: ObjectIdType
    $instrumentsIds: [String]
    $sourcePortfolioId: ObjectIdType
  ) {
    moveInstruments(
      destinationPortfolioId: $destinationPortfolioId
      instrumentsIds: $instrumentsIds
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const MOVE_ALL_INSTRUMENTS = gql`
  mutation moveAllInstruments(
    $destinationPortfolioId: ObjectIdType
    $sourcePortfolioId: ObjectIdType
  ) {
    moveInstruments(
      destinationPortfolioId: $destinationPortfolioId
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const COPY_INSTRUMENTS = gql`
  mutation copyInstruments(
    $portfolioId: ObjectIdType
    $instrumentsIds: [String]
    $sourcePortfolioId: ObjectIdType
  ) {
    copyInstruments(
      portfolioId: $portfolioId
      instrumentsIds: $instrumentsIds
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
      instruments {
        id
        name
        date
        volume
        artifactId
        addedDate
        isin
        currencyCode
        entityId
        entityName
      }
    }
  }
`;

export const COPY_ALL_INSTRUMENTS = gql`
  mutation copyInstruments($portfolioId: ObjectIdType, $sourcePortfolioId: ObjectIdType) {
    copyInstruments(portfolioId: $portfolioId, sourcePortfolioId: $sourcePortfolioId) {
      message
      instruments {
        id
        name
        date
        volume
        artifactId
        addedDate
        isin
        currencyCode
        entityId
        entityName
      }
    }
  }
`;

/**
 * FUNDS
 */

export const ADD_FUNDS = gql`
  mutation AddFunds($portfolioId: ObjectIdType, $artifactIdList: [ArtifactId]) {
    addFunds(portfolioId: $portfolioId, artifactIdList: $artifactIdList) {
      funds {
        id
      }
    }
  }
`;

export const DELETE_FUNDS = gql`
  mutation DeleteFunds($isins: [String], $portfolioId: ObjectIdType, $selectedAll: Boolean) {
    deleteFunds(isins: $isins, portfolioId: $portfolioId, selectedAll: $selectedAll) {
      message
    }
  }
`;

export const MOVE_FUNDS = gql`
  mutation moveFunds(
    $destinationPortfolioId: ObjectIdType
    $isins: [String]
    $sourcePortfolioId: ObjectIdType
  ) {
    moveFunds(
      destinationPortfolioId: $destinationPortfolioId
      isins: $isins
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const MOVE_ALL_FUNDS = gql`
  mutation moveAllFunds(
    $destinationPortfolioId: ObjectIdType
    $sourcePortfolioId: ObjectIdType
    $selectedAll: Boolean
  ) {
    moveFunds(
      destinationPortfolioId: $destinationPortfolioId
      sourcePortfolioId: $sourcePortfolioId
      selectAll: $selectAll
    ) {
      message
    }
  }
`;

export const COPY_FUNDS = gql`
  mutation copyFunds(
    $destinationPortfolioId: ObjectIdType
    $isins: [String]
    $sourcePortfolioId: ObjectIdType
  ) {
    copyFunds(
      destinationPortfolioId: $destinationPortfolioId
      isins: $isins
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const COPY_ALL_FUNDS = gql`
  mutation copyFunds(
    $portfolioId: ObjectIdType
    $sourcePortfolioId: ObjectIdType
    $selectedAll: Boolean
  ) {
    copyFunds(
      destinationPortfolioId: $portfolioId
      sourcePortfolioId: $sourcePortfolioId
      selectedAll: $selectedAll
    ) {
      message
    }
  }
`;

/**
 * RATING NEWS
 */

export const ADD_PORTFOLIO_RATING_NEWS = gql`
  mutation addRatingNews($portfolioId: ObjectIdType, $artifactIdList: [ArtifactId]) {
    addRatingNews(portfolioId: $portfolioId, artifactIdList: $artifactIdList) {
      ratingNews {
        artifactId
        language
        title
        addedDate
        publicationDate
      }
    }
  }
`;

export const COPY_PORTFOLIO_RATING_NEWS = gql`
  mutation CopyRatingNews(
    $artifactIds: [String]
    $portfolioId: ObjectIdType
    $sourcePortfolioId: ObjectIdType
  ) {
    copyRatingNews(
      portfolioId: $portfolioId
      artifactIds: $artifactIds
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const COPY_ALL_PORTFOLIO_RATING_NEWS = gql`
  mutation CopyRatingNews($portfolioId: ObjectIdType, $sourcePortfolioId: ObjectIdType) {
    copyRatingNews(portfolioId: $portfolioId, sourcePortfolioId: $sourcePortfolioId) {
      message
    }
  }
`;

export const MOVE_PORTFOLIO_RATING_NEWS = gql`
  mutation MoveRatingNews(
    $destinationPortfolioId: ObjectIdType
    $artifactIds: [String]
    $sourcePortfolioId: ObjectIdType
  ) {
    moveRatingNews(
      destinationPortfolioId: $destinationPortfolioId
      artifactIds: $artifactIds
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const MOVE_ALL_PORTFOLIO_RATING_NEWS = gql`
  mutation MoveRatingNews($destinationPortfolioId: ObjectIdType, $sourcePortfolioId: ObjectIdType) {
    moveRatingNews(
      destinationPortfolioId: $destinationPortfolioId
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const DELETE_PORTFOLIO_RATING_NEWS = gql`
  mutation DeleteRatingNews(
    $artifactIdList: [ArtifactId]
    $portfolioId: ObjectIdType
    $selectedAll: Boolean
  ) {
    deleteRatingNews(
      artifactIdList: $artifactIdList
      portfolioId: $portfolioI
      selectedAll: $selectedAll
    ) {
      message
    }
  }
`;

/**
 * RESEARCH
 */

export const ADD_RESEARCH_ITEMS = gql`
  mutation addResearches($artifactIdList: [ArtifactId], $portfolioId: ObjectIdType) {
    addResearches(artifactIdList: $artifactIdList, portfolioId: $portfolioId) {
      researches {
        artifactId
        language
        title
        addedDate
        publicationDate
      }
    }
  }
`;

export const COPY_RESEARCHES = gql`
  mutation copyResearches(
    $portfolioId: ObjectIdType
    $artifactIds: [String]
    $sourcePortfolioId: ObjectIdType
  ) {
    copyResearches(
      portfolioId: $portfolioId
      artifactIds: $artifactIds
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
      researches {
        artifactId
        language
        title
        addedDate
        publicationDate
      }
    }
  }
`;

export const COPY_ALL_RESEARCHES = gql`
  mutation copyResearches($portfolioId: ObjectIdType, $sourcePortfolioId: ObjectIdType) {
    copyResearches(portfolioId: $portfolioId, sourcePortfolioId: $sourcePortfolioId) {
      message
      researches {
        artifactId
        language
        title
        addedDate
        publicationDate
      }
    }
  }
`;

export const MOVE_RESEARCHES = gql`
  mutation moveResearches(
    $destinationPortfolioId: ObjectIdType
    $artifactIds: [String]
    $sourcePortfolioId: ObjectIdType
  ) {
    moveResearches(
      destinationPortfolioId: $destinationPortfolioId
      artifactIds: $artifactIds
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const MOVE_ALL_RESEARCHES = gql`
  mutation moveResearches($destinationPortfolioId: ObjectIdType, $sourcePortfolioId: ObjectIdType) {
    moveResearches(
      destinationPortfolioId: $destinationPortfolioId
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const DELETE_RESEARCH_ITEMS = gql`
  mutation deleteResearches(
    $artifactIdList: [ArtifactId]
    $portfolioId: ObjectIdType
    $selectedAll: Boolean
  ) {
    deleteResearches(
      artifactIdList: $artifactIdList
      portfolioId: $portfolioId
      selectedAll: $selectedAll
    ) {
      message
    }
  }
`;

/**
 * EVENTS
 */

export const ADD_EVENTS = gql`
  mutation AddEvents($portfolioId: ObjectIdType, $artifactIdList: [ArtifactId]) {
    addEvents(portfolioId: $portfolioId, artifactIdList: $artifactIdList) {
      events {
        artifactId
        title
        eventDate
        addedDate
        category
        industry
        region
        meta {
          externalId
          connectionLink
          userRegistered
          eventType
          eventStatus
        }
      }
    }
  }
`;

export const COPY_EVENTS = gql`
  mutation CopyEvents(
    $portfolioId: ObjectIdType
    $eventsIds: [String]
    $sourcePortfolioId: ObjectIdType
  ) {
    copyEvents(
      portfolioId: $portfolioId
      eventsIds: $eventsIds
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const COPY_ALL_EVENTS = gql`
  mutation CopyEvents($portfolioId: ObjectIdType, $sourcePortfolioId: ObjectIdType) {
    copyEvents(portfolioId: $portfolioId, sourcePortfolioId: $sourcePortfolioId) {
      message
    }
  }
`;

export const MOVE_EVENTS = gql`
  mutation MoveEvents(
    $destinationPortfolioId: ObjectIdType
    $eventsIds: [String]
    $sourcePortfolioId: ObjectIdType
  ) {
    moveEvents(
      destinationPortfolioId: $destinationPortfolioId
      eventsIds: $eventsIds
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const MOVE_ALL_EVENTS = gql`
  mutation MoveEvents($destinationPortfolioId: ObjectIdType, $sourcePortfolioId: ObjectIdType) {
    moveEvents(
      destinationPortfolioId: $destinationPortfolioId
      sourcePortfolioId: $sourcePortfolioId
    ) {
      message
    }
  }
`;

export const DELETE_EVENTS = gql`
  mutation DeleteEvents($eventsIds: [String], $portfolioId: ObjectIdType, $selectedAll: Boolean) {
    deleteEvents(eventsIds: $eventsIds, portfolioId: $portfolioId, selectedAll: $selectedAll) {
      message
    }
  }
`;
